import { useState } from 'react';
import { Logo } from '../components/Logo';
import { SettingsPanel } from '../components/SettingsPanel';
import { audio } from '../game/audio/audio';
import { api } from '../services/api';
import { useSession } from '../stores/session-store';

/** Main menu shown after login. */
export function MenuScreen() {
  const user = useSession((s) => s.user);
  const [settings, setSettings] = useState(false);
  const logout = async (): Promise<void> => {
    await api.logout().catch(() => {});
    useSession.getState().setUser(null);
    useSession.getState().go('auth');
  };
  return (
    <main className="screen">
      <div className="col" style={{ alignItems: 'center', width: '100%' }}>
        <Logo />
        <nav className="panel menu-card" aria-label="Main menu">
          <div className="muted" style={{ textAlign: 'center', fontSize: 12 }}>
            Signed in as <span className="gold">{user?.email}</span>
          </div>
          <button
            className="btn btn-primary btn-block"
            autoFocus
            onClick={() => {
              audio.play('ui_confirm');
              useSession.getState().go('realms');
            }}
          >
            Play
          </button>
          <button className="btn btn-block" onClick={() => setSettings(true)}>
            Settings
          </button>
          <button className="btn btn-ghost btn-block" onClick={() => void logout()}>
            Log out
          </button>
        </nav>
        <p className="muted" style={{ fontSize: 11, marginTop: 16, letterSpacing: '0.1em' }}>
          EARLY DEVELOPMENT BUILD · FIRST PLAYABLE MILESTONE
        </p>
      </div>
      {settings && (
        <div className="modal-backdrop" onClick={() => setSettings(false)}>
          <div className="panel modal" onClick={(e) => e.stopPropagation()}>
            <h2 className="panel-title">Settings</h2>
            <SettingsPanel />
            <div className="row" style={{ justifyContent: 'flex-end', marginTop: 12 }}>
              <button className="btn" onClick={() => setSettings(false)}>
                Close
              </button>
            </div>
          </div>
        </div>
      )}
    </main>
  );
}
